class NewSearchEmptyState extends HTMLElement {
  private pills: HTMLElement[] = [];
  private bookButton: HTMLElement | null = null;

  connectedCallback(): void {
    this.pills = Array.from(this.querySelectorAll<HTMLElement>("[data-pill]"));
    this.bookButton = this.querySelector<HTMLElement>("[data-search-book]");

    this.pills.forEach((pill) =>
      pill.addEventListener("click", this.onPillClick),
    );
    this.bookButton?.addEventListener("click", this.onBookClick);
  }

  disconnectedCallback(): void {
    this.pills.forEach((pill) =>
      pill.removeEventListener("click", this.onPillClick),
    );
    this.bookButton?.removeEventListener("click", this.onBookClick);
  }

  private get root(): HTMLElement | null {
    return this.closest<HTMLElement>(".quick-search, .drawer-menu");
  }

  private get input(): HTMLInputElement | null {
    return this.root?.querySelector<HTMLInputElement>("[data-input]") ?? null;
  }

  private onPillClick = (e: Event): void => {
    const pill = e.currentTarget as HTMLElement;
    const term =
      pill.querySelector<HTMLElement>(".new-search-empty-state__pill-label")
        ?.textContent?.trim() ?? "";
    const input = this.input;
    if (!term || !input) return;

    input.value = term;
    input.focus();
    input.dispatchEvent(new Event("input", { bubbles: true }));
  };

  private onBookClick = (): void => {
    this.root?.querySelector<HTMLElement>("[data-close-icon]")?.click();
  };
}

customElements.define("new-search-empty-state", NewSearchEmptyState);
